var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/jqsjxt_1_1.mp4",
                    'title':"自动拆码垛",
                    'lable':"自动拆码垛方案目前已经普遍应用于各类工业生产和运输流通企业，可大量替换人工，极大提高工作效率和生产安全水平，目前已在汽车配件、工程机械、食品饮料、家电、家具、物流等多个行业广泛应用，增长很快，预计将在所有的生产行业中得到普及应用。",
                    'list':[
                        {
                            'icon':"/static/case/wd.png",
                            'title':"成熟稳定可靠"
                        },
                        {
                            'icon':"/static/case/xj.png",
                            'title':"多种精度相机可供选择"
                        },
                        {
                            'icon':"/static/case/jqr.png",
                            'title':"适配多种类型机器人"
                        }
                        ,
                        {
                            'icon':"/static/case/ptkf.png",
                            'title':"提供标准软件方案"
                        }
                        ,
                        {
                            'icon':"/static/case/ptkf.png",
                            'title':"强大的二次开发平台"
                        }
                        
                    ]
                }
            ]
        }
        ,
        {
            'name':"控制系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/kzxt_1_1.mp4",
                    'title':"并联机器人控制器的应用",
                    'lable':"全自主研发，深度兼容并联Delta机器人，通用匹配其他类型机器人",
                    'list':[
                        {
                            'icon':"/static/case/jd.png",
                            'title':"更高的精度"
                        },
                        {
                            'icon':"/static/case/sd.png",
                            'title':"更快的速度"
                        },
                        {
                            'icon':"/static/case/xn.png",
                            'title':"更强的性能"
                        }
                    ]
                }
            ]
        }
        ,
        {
            'name':"伺服电机",
            'list':[
                {
                    'videoUrl':"",
                    'title':"",
                    'lable':"",
                    'list':[
                    ]
                }
            ]
        }
        ,
        {
            'name':"伺服驱动器",
            'list':[
                {
                    'videoUrl':"",
                    'picUrl':"/static/industry/qingyuantechuangrobot.jpg",
                    'title':"CoolDrive RD高性能工业机器人伺服解决方案",
                    'lable':"在组装、包装等自动化产线中，受工位多、产量大、紧凑生产的影响，机器人变得越来越小。清能德创CoolDrive RD高性能伺服驱动可以在更小的电气柜中实现运动功能，并且可根据应用需求，进行定制化服务。",
                    'list':[
                        {
                            'icon':"/static/case/ethercattx.png",
                            'title':"EtherCAT通信、实时性强、接线简单、提升工作效率"
                        },
                        {
                            'icon':"/static/case/tjxq.png",
                            'title':"体积小巧、大幅减少电气柜尺寸、实现紧凑生产"
                        },
                        {
                            'icon':"/static/case/gzdlkaxqpz.png",
                            'title':"各轴电流可按需求配置、模块化标准化设计、定制周期短、性价比高"
                        },
                        {
                            'icon':"/static/case/zdjqr.png",
                            'title':"针对机器人开发多种应用功能、提升稳定性与精准度、助力高效生产"
                        },
                        {
                            'icon':"/static/case/aqgndjc.png",
                            'title':"安全功能的集成，提高设备的安全可靠性，降低成本"
                        }
                    ]
                }
            ]
        }
        ,
        {
            'name':"RV减速机",
            'list':[
                {
                    //'videoUrl':"",
                    'picUrl':"https://image.sjyuan.net.cn/video/mvb/case/%E5%B7%A5%E4%B8%9A%E6%9C%BA%E5%99%A8%E4%BA%BA%E9%9B%B6%E9%83%A8%E4%BB%B6%28CRDS-E%29.jpg",
                    'title':"CT-CRD-E系列减速机在码垛机器人上的应用",
                    'lable':"应用于机械加工中心送料装置、自动换刀装置、高精度转台、非标自动化等需要精确定位的场景。",
                    'list':[
                        {
                            'icon':"/static/case/zksj.png",
                            'title':"中实设计"
                        },
                        {
                            'icon':"/static/case/az.png",
                            'title':"安装方便"
                        },
                        {
                            'icon':"/static/case/rhzfr.png",
                            'title':"润滑脂已封入"
                        }
                        ,
                        {
                            'icon':"/static/case/jd.png",
                            'title':"高精度，误差小于1弧分"
                        }
                        ,
                        {
                            'icon':"/static/case/ngz.png",
                            'title':"耐过载"
                        }
                        ,
                        {
                            'icon':"/static/case/xn.png",
                            'title':"良好的加减速性能"
                        }
                        
                    ]
                }
                ,
                {
                    //'videoUrl':"",
                    'picUrl':"https://image.sjyuan.net.cn/video/mvb/case/%E5%B7%A5%E4%B8%9A%E6%9C%BA%E5%99%A8%E4%BA%BA%E9%9B%B6%E9%83%A8%E4%BB%B6%28CRV-E%29.jpg",
                    'title':"CT-CRV-E系列减速机在码垛机器人上的应用",
                    'lable':"应用于工业机器人、数控机床、变位机、非标自动化等行业。",
                    'list':[
                        {
                            'icon':"/static/case/jgjc.png",
                            'title':"结构紧凑"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"高精度，误差小于1弧分"
                        },
                        {
                            'icon':"/static/case/ggx.png",
                            'title':"高刚性"
                        }
                        ,
                        {
                            'icon':"/static/case/ngz.png",
                            'title':"耐过载"
                        }
                        ,
                        {
                            'icon':"/static/case/xn.png",
                            'title':"良好的加减速性能"
                        }
                        ,
                        {
                            'icon':"/static/case/djsb.png",
                            'title':"大减速比，81-201"
                        }
                        ,
                        {
                            'icon':"/static/case/zyd.png",
                            'title':"噪音低"
                        }
                        ,
                        {
                            'icon':"/static/case/zdx.png",
                            'title':"振动小"
                        }
                        ,
                        {
                            'icon':"/static/case/smc.png",
                            'title':"寿命长，可达到10000h。"
                        }
                        
                    ]
                }
            ]
        }
    ],
    name:"工业机器人零部件",
    title:"solutions",
    subtitle:"工业机器人零部件应用案例",
    subinfo:"我们的应用案例包括工业机器人的核心零部件、控制系统以及视觉系统，可帮您按照所需的设备综合效率来规划和运行机器和设备。",
}

export default {
    industryInfo
  };


// WEBPACK FOOTER //
// ./src/data/industryInfo/1.js